import Text from '~/components/Text';
import CopyIcon from '~/icons/CopyIcon';
import DownloadIcon from '~/icons/DownloadIcon';
import ExternalLinkIcon from '~/icons/ExternalLinkIcon';
import { copyToClipboard, openInNewTab } from '~/utils/utils';
import * as Styles from './styles';

interface IInvoiceLinkProps {
  invoiceUuid: string;
  pdfUrl: string;
}

const InvoiceLink = ({ invoiceUuid, pdfUrl }: IInvoiceLinkProps) => {
  const publicLink = `${process.env.LANDING_PAGE_URL}/shared/${invoiceUuid}/`;

  return (
    <>
      <Text size="xs" variant="neutral" className="semi-bold">
        Invoice link
      </Text>

      <Styles.LinkWrapper>
        <Styles.LinkContainer
          onClick={() => {
            openInNewTab(publicLink);
          }}
          className="spread"
        >
          <Styles.LinkTextContainer>
            <Text size="xs" variant="neutral">
              {publicLink}
            </Text>
          </Styles.LinkTextContainer>
          <Styles.LinkButtonContainer>
            <Styles.IconButton
              onClick={e => {
                e.stopPropagation();
                openInNewTab(publicLink);
              }}
            >
              <ExternalLinkIcon />
            </Styles.IconButton>
            <Styles.IconButton
              onClick={e => {
                e.stopPropagation();
                copyToClipboard(publicLink, 'Invoice link copied to clipboard');
              }}
            >
              <CopyIcon />
            </Styles.IconButton>
          </Styles.LinkButtonContainer>
        </Styles.LinkContainer>

        <Styles.DownloadButton onClick={() => openInNewTab(pdfUrl)}>
          <DownloadIcon />
        </Styles.DownloadButton>
      </Styles.LinkWrapper>
    </>
  );
};

export default InvoiceLink;
